import { Grid, Box } from '@mui/material';
import PropTypes from 'prop-types';
import NoteCard from './NoteCard';

const RowNotes = ({ notes = [] }) => {
  const validNotes = Array.isArray(notes) ? notes : [];
  let quantityColumns = 3;
  if (validNotes.length === 2) {
    quantityColumns = 2;
  } else if (validNotes.length === 1) {
    quantityColumns = 1;
  }
  return (
    <Grid container>
      {validNotes.map((data) => (
        <Grid key={data.image} item xs={12} md={quantityColumns === 1 ? 12 : quantityColumns === 2 ? 6 : 4}>
          <Box display="flex" alignItems="center" justifyContent="center">
            <NoteCard noteId={String(data.note_id)} title={data.title} image={data.image} description={data.text} />
          </Box>
          <Box sx={{ height: '70px' }} />
        </Grid>
      ))}
    </Grid>
  );
};

RowNotes.propTypes = {
  notes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default RowNotes;
